<template>
  <ResearchGalleryPage
    page-title="党建工作"
    section-label="科研保障"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
    :groups="groups"
  />
</template>

<script>
import ResearchGalleryPage from '@/components/ResearchGalleryPage.vue';

export default {
  name: 'LanhuDangjiangongzuo',
  components: {
    ResearchGalleryPage
  },
  data() {
    return {
      sectionRoute: '/lanhu_keyanbaozhang',
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      groups: [
        {
          title: '党委换届与组织建设',
          kicker: '2016',
          columns: 1,
          items: [
            {
              src: require('./assets/html/party-2016-congress.jpg'),
              caption: '2016 年 12 月，出席新闻与传播研究所党委换届选举大会的全体党员合影',
              contain: true
            },
            {
              src: require('./assets/html/party-2016-committee.jpg'),
              caption: '2016 年 12 月，在新闻与传播研究所党委换届选举大会上，新当选的所党委、纪委成员合影'
            }
          ]
        },
        {
          title: '主题学习与党员活动',
          kicker: '2010-2018',
          items: [
            {
              src: require('./assets/html/party-2011-chorus.jpg'),
              caption: '2011 年 6 月，新闻与传播研究所党委书记庄前生带领所党员干部参加中国社会科学院庆祝建党 90 周年歌咏比赛'
            },
            {
              src: require('./assets/html/party-2012-zunyi.jpg'),
              caption: '2012 年 7 月，新闻与传播研究所党员干部参观贵州遵义会议旧址'
            },
            {
              src: require('./assets/html/party-2010-branch.jpg'),
              caption: '2010 年 7 月 1 日，新闻与传播研究所行政和科研两个党支部为党员转正召开支部大会'
            },
            {
              src: require('./assets/html/party-2017-study.jpg'),
              caption: '2017 年 12 月，新闻与传播研究所组织学习党的十九大精神，邀请中国社会科学院信息情报研究院党委书记、研究员姜辉宣讲习近平新时代中国特色社会主义思想'
            },
            {
              src: require('./assets/html/party-2018-museum.jpg'),
              caption: '2018 年 6 月，新闻与传播研究所党委组织党员干部参观国家博物馆“真理的追求：庆祝马克思诞辰 200 周年展览”'
            }
          ]
        }
      ]
    };
  }
};
</script>
